import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import SEO from "../components/SEO";
import { makeStyles } from "@material-ui/core";
import { motion, transform } from "framer-motion";
import Link from "../components/v2/Link";
import LazyImage from "../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../components/v4/FaqSection/FaqSection";

import spark1 from "../images/v4/whatsappPage/icons/spark1.svg";
import spark2 from "../images/v4/whatsappPage/icons/spark2.svg";
import spark3 from "../images/v4/whatsappPage/icons/spark3.svg";
import spark4 from "../images/v4/whatsappPage/icons/spark4.svg";

import industryIntegration from "../images/v4/industryPage/industryIntegration.png";

import teamsPageHeroImg from "../images/v4/TgPages/MainPage/heroimg.png";
import industryPageHerobg from "../images/v4/TgPages/MainPage/heroBg.png";

import adaptImg1 from "../images/v4/industryPage/adapttImg1.png";
import adaptImg2 from "../images/v4/industryPage/adapttImg2.png";
import adaptImg3 from "../images/v4/industryPage/adapttImg3.png";
import adaptImg4 from "../images/v4/industryPage/adapttImg4.png";
import adaptImg5 from "../images/v4/industryPage/adapttImg5.png";

import partnerIcon1 from "../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../images/v4/aiPage/icons/partnerIcon8.png";

import teamsPerfomanceImg from "../images/v4/TgPages/MainPage/teamPerform.png";

import moreSideRightButton from "../images/v4/industryPage/learnmoreright.png";
import industryadaptbg from "../images/v4/industryPage/industryAdaptbg.png";
import industryintegrationImg from "../images/v4/industryPage/industryIntegrationbg.png";
import bussinessSuccessbg from "../images/v4/industryPage/bussinessSuccessbg.png";

import contentIcon1 from "../images/v4/TgPages/MainPage/contentIcon/img1.svg";
import contentIcon2 from "../images/v4/TgPages/MainPage/contentIcon/img2.svg";
import contentIcon3 from "../images/v4/TgPages/MainPage/contentIcon/img3.svg";
import contentIcon4 from "../images/v4/TgPages/MainPage/contentIcon/img4.svg";
import contentIcon5 from "../images/v4/TgPages/MainPage/contentIcon/img5.svg";
import contentIcon6 from "../images/v4/TgPages/MainPage/contentIcon/img6.svg";
import contentIcon7 from "../images/v4/TgPages/MainPage/contentIcon/img7.svg";
import contentIcon8 from "../images/v4/TgPages/MainPage/contentIcon/img8.svg";

import leadCaptureIcon from "../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../images/v4/industryPage/videoConference.png";
import TruestedSection from "../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../components/v3/TestimonialSlider/TestimonialSlider";
import transformBackgroundImage from "../images/v4/linkGeneration/images/transformBackgroundImage.png";
import transitions from "@material-ui/core/styles/transitions";

// Function to distribute icons across three tracks

const useStyles = makeStyles((theme) => ({
	IndustrySection: {
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		backgroundImage: `url(${industryPageHerobg})`,
		padding: "60px 0 40px",
		"& $aiSectionLeft": {
			width: "50%",
			gap: "25px",
		},
		"& .container": {
			paddingBottom: "40px",
		},

		"& .centerContainer": {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			gap: "32px",
			width: "80%",
			margin: "0 auto",
			textAlign: "center",
			marginTop: "70px",
		},
		"@media only screen and (max-width: 600px)": {
			"& $aiSectionLeft": {
				width: "100%",
			},
			paddingTop: "0px",
			"& .centerContainer": {
				width: "100%",
				marginTop: "30px",
			},
			"& .container": {
				paddingBottom: "20px",
			},
		},
	},
	aiSectionContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: "60px",
		"@media only screen and (max-width: 600px)": {
			flexDirection: "column",
		},
	},
	aiSectionLeft: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		width: "50%",
		gap: "20px",
		"& .highlighterText": {
			background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
			WebkitBackgroundClip: "text",
			WebkitTextFillColor: "transparent",
		},
		"@media only screen and (max-width: 600px)": {
			width: "100%",
		},
	},
	aiSectionRight: {
		width: "40%",
		"@media only screen and (max-width: 600px)": {
			width: "100%",
		},
	},
	integrationindustryHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		width: "100%",
		"@media only screen and (max-width: 600px)": {
			flexDirection: "column",
			gap: "30px",
		},
	},
	integrationContent: {
		width: "100%",
		textAlign: "center",
		maxWidth: "800px",
		margin: "0 auto 48px",
		"& h2": {
			marginBottom: "16px !important",
			marginTop: "0 !important",
		},
		"@media only screen and (max-width: 600px)": {
			width: "100%",
			marginBottom: "20px",
		},
	},

	performanceSection: {
		padding: "40px 0",
		backgroundImage: `url(${teamsPerfomanceImg})`,
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		"& $integrationLeft": {
			width: "50%",
			gap: "20px",
			display: "flex",
			flexDirection: "column",
			justifyContent: "flex-start",
			alignItems: "fle-start",
		},
		"@media only screen and (max-width: 600px)": {
			padding: "40px 0",
			"& $integrationLeft": {
				width: "100%",
			},
		},
	},
	bussinessSuccesSection: {
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		backgroundImage: `url(${bussinessSuccessbg})`,
		paddingBottom: "200px",
		paddingTop: "100px",
		"& .logos-container": {
			background: "transparent",
			"&::before,&::after": {
				display: "none",
			},
			"& .logo": {
				backgroundColor: "#208EEC26",
				color: "#B6DDFF",
				"& img": {
					width: "48px",
					height: "48px",
				},
			},
		},
		"@media only screen and (max-width: 600px)": {
			padding: "80px 0 120px",
		},
	},
	statsContainer: {
		display: "flex",
		alignItems: "stretch",
		flexWrap: "wrap",
		gap: "24px",
		justifyContent: "flex-start",
		width: "100%",
		marginTop: "40px",
		"@media only screen and (max-width: 600px)": {
			flexDirection: "column",
			gap: "15px",
			marginTop: "20px",
			position: "relative",
		},
	},
	customerExperencesBox: {
		width: "32%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		gap: "50px",
		background: "linear-gradient(129deg, rgba(255, 255, 255, 0.10) 0%, rgba(0, 137, 255, 0.10) 100%)",
		borderRadius: "16px",
		padding: "20px",
		minHeight: "230px",
		backdropFilter: "blur(30px) brightness(0.8)",
		overflow: "hidden",
		transition: ".2s ease-in-out",
		"&:hover": {
			background: "linear-gradient(129deg, rgba(255, 255, 255, 0.30) 0%, rgba(0, 137, 255, 0.30) 100%)",
		},
		"& p:nth-child(2)": {
			color: "#fff",
		},
		"& p:last-child": {
			color: "#fff",
		},
		"@media only screen and (max-width: 600px)": {
			width: "100%",
			gap: "15px",
			padding: "15px",
			borderRadius: "20px",
			minHeight: "max-content",
		},
		"&.orangeCard1": {
			background: "#401960",
			"&.glass-effect": {
				"&::before": {
					content: '""',
					position: "absolute",
					width: "250px",
					height: "250px",
					zIndex: "-1",
					background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
					borderRadius: "50%",
					filter: "blur(100px)",
					opacity: "var(--before-opacity, 0)",
					left: "var(--before-left, 0)",
					top: "var(--before-top, 0)",
					transition: "opacity 0.3s ease",
					pointerEvents: "none",
				},
			},
		},
		"&.orangeCard3": {
			background: "#401960",
			"&.glass-effect": {
				"&::before": {
					content: '""',
					position: "absolute",
					width: "250px",
					height: "250px",
					zIndex: "-1",
					background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
					borderRadius: "50%",
					filter: "blur(100px)",
					opacity: "var(--before-opacity, 0)",
					left: "var(--before-left, 0)",
					top: "var(--before-top, 0)",
					transition: "opacity 0.3s ease",
					pointerEvents: "none",
				},
			},
		},
		"&.orangeCard7": {
			background: "#401960",
			"&.glass-effect": {
				"&::before": {
					content: '""',
					position: "absolute",
					width: "250px",
					height: "250px",
					zIndex: "-1",
					background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
					borderRadius: "50%",
					filter: "blur(100px)",
					opacity: "var(--before-opacity, 0)",
					left: "var(--before-left, 0)",
					top: "var(--before-top, 0)",
					transition: "opacity 0.3s ease",
					pointerEvents: "none",
				},
			},
		},
		"&.orangeCard5": {
			background: "#401960",
			"&.glass-effect": {
				"&::before": {
					content: '""',
					position: "absolute",
					width: "250px",
					height: "250px",
					zIndex: "-1",
					background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
					borderRadius: "50%",
					filter: "blur(100px)",
					opacity: "var(--before-opacity, 0)",
					left: "var(--before-left, 0)",
					top: "var(--before-top, 0)",
					transition: "opacity 0.3s ease",
					pointerEvents: "none",
				},
			},
		},
		"&.blueCard3": {
			background: "rgba(0, 154, 153, 0.4)",
			"&.glass-effect": {
				"&::before": {
					content: '""',
					position: "absolute",
					width: "250px",
					height: "250px",
					zIndex: "-1",
					background: "radial-gradient(circle, #1ADAD9 50%, #00aa7c 50%)",
					borderRadius: "50%",
					filter: "blur(100px)",
					opacity: "var(--before-opacity, 0)",
					left: "var(--before-left, 0)",
					top: "var(--before-top, 0)",
					transition: "opacity 0.3s ease",
					pointerEvents: "none",
				},
			},
		},
		"&.regularCard0": {
			background: "#210538",
			"&.glass-effect": {
				"&::before": {
					content: '""',
					position: "absolute",
					width: "250px",
					height: "250px",
					zIndex: "-1",
					background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
					borderRadius: "50%",
					filter: "blur(100px)",
					opacity: "var(--before-opacity, 0)",
					left: "var(--before-left, 0)",
					top: "var(--before-top, 0)",
					transition: "opacity 0.3s ease",
					pointerEvents: "none",
				},
			},
		},
		"&.regularCard2": {
			background: "#210538",
			"&.glass-effect": {
				"&::before": {
					content: '""',
					position: "absolute",
					width: "250px",
					height: "250px",
					zIndex: "-1",
					background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
					borderRadius: "50%",
					filter: "blur(100px)",
					opacity: "var(--before-opacity, 0)",
					left: "var(--before-left, 0)",
					top: "var(--before-top, 0)",
					transition: "opacity 0.3s ease",
					pointerEvents: "none",
				},
			},
		},
		"&.regularCard4": {
			background: "#210538",
			"&.glass-effect": {
				"&::before": {
					content: '""',
					position: "absolute",
					width: "250px",
					height: "250px",
					zIndex: "-1",
					background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
					borderRadius: "50%",
					filter: "blur(100px)",
					opacity: "var(--before-opacity, 0)",
					left: "var(--before-left, 0)",
					top: "var(--before-top, 0)",
					transition: "opacity 0.3s ease",
					pointerEvents: "none",
				},
			},
		},
		"&.regularCard6": {
			background: "#210538",
			"&.glass-effect": {
				"&::before": {
					content: '""',
					position: "absolute",
					width: "250px",
					height: "250px",
					zIndex: "-1",
					background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
					borderRadius: "50%",
					filter: "blur(100px)",
					opacity: "var(--before-opacity, 0)",
					left: "var(--before-left, 0)",
					top: "var(--before-top, 0)",
					transition: "opacity 0.3s ease",
					pointerEvents: "none",
				},
			},
		},
		"&.greenCard7": {
			background: "#002C51",
			"&.glass-effect": {
				"&::before": {
					content: '""',
					position: "absolute",
					width: "250px",
					height: "250px",
					zIndex: "-1",
					background: "radial-gradient(circle, #208EEC 50%, #002C51 50%)",
					borderRadius: "50%",
					filter: "blur(100px)",
					opacity: "var(--before-opacity, 0)",
					left: "var(--before-left, 0)",
					top: "var(--before-top, 0)",
					transition: "opacity 0.3s ease",
					pointerEvents: "none",
				},
			},
		},
	},
	customerExperencesBoxBody: {
		display: "flex",
		width: "100%",
		flexDirection: "column",
		justifyContent: "space-between",
		flex: "1",
		alignItems: "stretch",
		gap: "24px",

		"@media only screen and (max-width: 600px)": {
			width: "100%",
		},
		"& .description": {
			flex: "1",
		},
	},
	learnMorelink: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		width: "100%",
	},
	moreSideButton: {
		width: "42px",
		minWidth: "42px",
		minHeight: "42px",
		height: "42px",
		position: "relative",
		borderRadius: "50%",
		overflow: "hidden",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"&::after": {
			content: '""',
			position: "absolute",
			top: "0",
			left: "0",
			width: "100%",
			height: "100%",
			opacity: "0.2",
			backgroundColor: "#fff",
		},
		"& img": {
			width: "24px",
			height: "24px",
			transform: "rotate(-90deg)",
		},
	},
	statsFontImg: {
		width: "48px",
		height: "48px",
		"& img": {
			width: "100%",
			height: "100%",
		},
	},
	tabsSection: {
		background: "#FFF9F0",
		"& .centerContainer": {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			gap: "32px",
			width: "80%",
			margin: "0 auto",
			textAlign: "center",
		},
		"@media only screen and (max-width: 600px)": {
			"& .centerContainer": {
				width: "100%",
			},
		},
	},
	tabsContainer: {
		width: "80%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "8px",
		border: "2px solid #DBDBDB",
		borderRadius: "40px",
		background: "#fff",
		"@media only screen and (max-width: 600px)": {
			width: "100%",
			padding: "5px",
		},
	},
	tab: {
		width: "33%",
		background: "",
		padding: "18px",
		background: "transparent",
		borderRadius: "40px",
		background: "transparent",
		transition: "0.3s ease",
		cursor: "pointer",
		"&.active": {
			color: "white",
			background: "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
		},
		"@media only screen and (max-width: 600px)": {
			minWidth: "max-content",
			padding: "10px",
		},
	},
	tabCard: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		"@media only screen and (max-width: 600px)": {
			marginTop: "30px",
			flexDirection: "column",
		},
	},
	tabCardLeftContainer: {
		display: "flex",
		gap: "40px",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		"@media only screen and (max-width: 600px)": {
			gap: "20px",
		},
	},
	benfitListContainer: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		gap: "30px",
		marginTop: "50px",
		"@media only screen and (max-width: 600px)": {
			gap: "15px",
			marginTop: "20px",
		},
	},
	benfitListItem: {
		display: "flex",
		width: "100%",
		margin: "0 auto",
		justifyContent: "flex-start",
		alignItems: "center",
		gap: "15px",
		position: "relative",
		"@media only screen and (max-width: 600px)": {
			width: "100%",
			gap: "15px",
			alignItems: "flex-start",
		},
	},
	benfitListItemContent: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		gap: "10px",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		"@media only screen and (max-width: 600px)": {
			width: "100%",
		},
	},
	benfitIcon: {
		width: "55px",
		"@media only screen and (max-width: 600px)": {
			width: "40px",
		},
	},
	adaptFeatures: {
		paddingTop: "0",
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		backgroundImage: `url(${industryadaptbg})`,
		"& .header": {
			display: "flex",
			width: "100%",
			gap: "50px",
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "flex-start",
			textAlign: "left",
			"& h2": {
				width: "50%",
			},
			"& p": {
				width: "50%",
			},
			"@media(max-width: 768px)": {
				gap: "24px",
				flexDirection: "column",
				justifyContent: "flex-start",
				"& h2": {
					width: "100%",
				},
				"& p": {
					width: "100%",
				},
			},
		},
		"& .body": {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			width: "100%",
			marginTop: "50px",
		},
		"@media only screen and (max-width: 600px)": {
			"& .header": {
				width: "100%",
			},
			"& .body": {
				flexDirection: "column",
				flexWrap: "wrap",
				rowGap: "15px",
			},
		},
		"@media only screen and (min-width: 1900px)": {
			"& .container": {
				paddingTop: "20px",
			},
		},
		"& .swiper-wrapper": {
			alignItems: "streach",
			padding: "16px 8px",
		},
	},
	featureContainer: {
		width: "24%",
		gap: "16px",
		boxShadow: "0px 0px 16px #C1D7DB66",
		borderRadius: "16px",
		background: "#fff",
		padding: "16px",
		display: "flex",
		gap: "10px",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		textAlign: "left",
		"& p": {
			width: "80%",
		},
		"@media only screen and (max-width: 600px)": {
			width: "100%",
			"& p": {
				width: "100%",
			},
		},
	},
	commonPageFooterSection: {
		background: "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
		"& .centerContainer": {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			gap: "32px",
			width: "80%",
			margin: "0 auto",
			textAlign: "center",
		},
		"@media only screen and (max-width: 600px)": {
			"& .centerContainer": {
				width: "100%",
			},
		},
	},
	featureIcon: {
		marginBottom: "15px",
	},
	resultCard: {
		maxWidth: "500px",
		display: "flex!important",
		flexDirection: "row",
		alignItems: "stretch",
		justifyContent: "flex-start",
		borderRadius: "10px",
		overflow: "hidden",
		boxShadow: "0px 0px 20px #E3E2FD",
		"@media only screen and (max-width: 600px)": {
			maxWidth: "90%",
		},
	},
	successHeader: {
		maxWidth: "500px",
		width: "100%",
		height: "320px",
		padding: "16px",
		backgroundSize: "cover",
		backgroundPosition: "top",
		"@media only screen and (max-width: 600px)": {
			maxWidth: "100%",
			backgroundSize: "cover",
			backgroundPosition: "top",
		},
	},
	resultBody: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		maxWidth: "500px",
		padding: "24px",
		gap: "16px",
		minHeight: "140px",
		backgroundColor: "#fff",
		"& img": {
			width: "150px",
		},
		"@media only screen and (max-width: 600px)": {
			maxWidth: "100%",
			minHeight: "140px",
			"& img": {
				width: "140px",
			},
		},
	},
	tag: {
		background: "#FFFFFF33",
		backdropFilter: "blur(30px) brightness(0.8)",
		borderRadius: "50px",
		padding: "10px 16px",
		width: "max-content",
	},
	successStorySlider: {
		padding: "30px 120px  !important",
		"@media only screen and (max-width: 600px)": {
			padding: "30px 15px  !important",
		},
	},
	resultSection: {
		backgroundColor: "#F1FFFE",
		"& .centerContainer": {
			textAlign: "center",
			"& h2": {
				marginBottom: "24px",
			},
		},
	},
	partnerSlide: {
		width: "144px !important",
		filter: "brightness(0.1)",
		"& img": {
			width: "144px",
		},
		"@media only screen and (max-width: 600px)": {
			width: "max-content !important",
			"& img": {
				width: "100px",
			},
			// marginRight: "20px !important",
		},
	},
	partnerSlider: {
		padding: "10px 0  65px !important",
		"@media only screen and (max-width: 600px)": {
			paddingBottom: "40px !important",
		},
	},
	integrationRightImage: {
		width: "100%",
	},
	performanceImage: {
		position: "absolute",

		zIndex: "0",
		"& img": {
			width: "100%",
		},
		"@media only screen and (max-width: 600px)": {
			position: "relative",
		},
	},
	broadcastContainer: {
		background: "#EFFFFB",
		"& .centerContainer": {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			gap: "32px",
			width: "60%",
			margin: "0 auto",
			textAlign: "center",
		},
		"@media only screen and (max-width: 600px)": {
			"& .centerContainer": {
				width: "100%",
			},
		},
	},
	broadcastContainerInnerBox: {
		width: "100%",
		padding: "20px",
		"&:last-child": {
			background: "#fff",
			"& $broadcastPointer::before": {
				display: "none",
			},
		},
	},
	broadcastContainerInner: {
		gap: "30px",
		width: "100%",
		display: "flex",
		// padding: "0 8rem 1rem 8rem",
		padding: "0 0rem 1rem 0rem",
		alignItems: "stretch",
		justifyContent: "flex-start",
		// cursor: "grab",
		// "&::-webkit-scrollbar-track": {
		//   "-webkit-box-shadow": "none",
		//   backgroundColor: "#EDF1F6",
		// },

		// "&::-webkit-scrollbar": {
		//   width: "5px",
		//   height: "5px",
		//   borderRadius: "50%",
		//   backgroundColor: "#EDF1F6",
		// },

		// "&::-webkit-scrollbar-thumb": {
		//   backgroundColor: "#D2DBE4",
		//   borderRadius: "50px",
		// },
		"@media only screen and (max-width: 600px)": {
			padding: "0 15px",
			paddingBottom: "10px",
		},
		"@media only screen and (min-width: 1900px)": {},
	},
	broadcastRightContainer: {
		position: "absolute",
		top: "0",
		left: "0",
	},
	adaptsBox: {
		gap: "16px",
		display: "flex",
		padding: "24px",
		background: "#fff",
		alignItems: "stretch",
		borderRadius: "20px",
		flexDirection: "column",
		justifyContent: "flex-start",
		boxShadow: "0px 0px 24px #D4E0E9",
		borderRadius: "16px",
		maxWidth: "380px",
		// minHeight: "220px",
		"@media only screen and (max-width: 600px)": {
			padding: "15px",
			maxWidth: "80%",
			gap: "15px",
		},
	},
	broadcastBoxInnerContainer: {
		gap: "40px",
		width: "90%",
		margin: "0 auto",
		display: "flex",
		position: "relative",
		maxWidth: "1200px",
		alignItems: "center",
		justifyContent: "flex-start",
	},
	broadcastOption: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		gap: "10px",
	},
	broadcastText: {
		color: "#B9E0E0",
	},
	broadcastPointer: {
		color: "#fff",
		border: "1px solid #fff",
		borderRadius: "50%",
		padding: "5px 11px",
		background: "transparent",
		position: "relative",
		"&::before": {
			content: '""',
			position: "absolute",
			top: "100%",
			left: "50%",
			height: "140%",
			borderRight: "1px dotted",
		},
	},
	adaptDescription: {
		gap: "10px",
		minHeight: "80px",
		"@media only screen and (max-width: 600px)": {
			alignItems: "baseline",
		},
	},
	adaptBoxImg: {
		width: "48px",
		maxWidth: "48px",
		position: "relative",
		bottom: "0",
		marginBottom: "24px",
	},
	scrollPrompt: {
		position: "fixed",
		bottom: "20px",
		left: "50%",
		transform: "translateX(-50%)",
		background: "rgba(0, 0, 0, 0.7)",
		padding: "10px 20px",
		borderRadius: "8px",
	},
	wpFaq: {
		"& section": {
			padding: "0px 0 40px !important",
		},
		"@media only screen and (max-width: 600px)": {
			"& section": {
				padding: "0px 0 40px !important",
			},
		},
	},
	belowText: {
		width: "100%",
		textAlign: "right",
		color: "#9279B1",
		marginTop: "10px",
	},
	pointerImg: {
		"& img": {
			width: "28px",
		},
		"@media only screen and (max-width: 600px)": {
			"& img": {
				width: "10px",
			},
		},
	},
	cardHeader: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		width: "100%",
		gap: "5px",
		flexDirection: "column",
		"& p": {
			minHeight: "64px",
		},
	},
	header: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		width: "100%",
		gap: "20px",
		flexDirection: "column",
		"@media only screen and (max-width: 600px)": {
			gap: "10px",
		},
	},
	aiPoweredContainer: {
		backgroundColor: "#F1FFFE",
	},
	aiPoweredClientContainer: {
		textAlign: "center",
	},
	integrationSection: {
		backgroundImage: `url(${industryintegrationImg})`,
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		paddingTop: "250px",
		"@media only screen and (max-width: 600px)": {
			paddingTop: "160px",
		},
		"& .primaryButtonOutline": {
			minWidth: "auto",
		},
	},
	integrationHeader: {
		display: "flex",
		alignItems: "center",
		flexDirection: "row",
		"@media only screen and (max-width: 600px)": {
			flexDirection: "column",
		},
		"& div": {
			width: "50%",
			"@media only screen and (max-width: 600px)": {
				width: "100%",
			},
		},
		"& .buttonContaienr": {
			marginTop: "42px",
			"& a": {
				color: "#FF682A",

				"&:hover": {
					color: "#fff",
				},
			},
		},
	},
	testimonialSection: {},
	testimonialContainer: {
		width: "100%",
		overflow: "hidden",
		padding: "10px 0 !important",
		paddingBottom: "80px !important",
		"& .swiper-wrapper": {
			transitionTimingFunction: "linear",
		},
		"@media only screen and (max-width: 600px)": {
			paddingBottom: "40px",
			minHeight: "430px",
		},
	},
	testimonialCard: {
		maxWidth: "590px",
		display: "flex !important",
		overflow: "hidden",
		maxHeight: "320px",
		boxShadow: "0px 0px 20px #E3E2FD",
		alignItems: "stretch",
		borderRadius: "8px",
		justifyContent: "flex-start",
		flexShrink: "0",
		height: "auto",
		"@media only screen and (max-width: 768px)": {
			maxWidth: "300px",
			maxHeight: "max-content",
			minHeight: "630px",
			flexDirection: "column",
			height: "630px",
		},
	},
	testimonialUserImg: {
		width: "100%",
		height: "100%",
		"@media only screen and (max-width: 768px)": {
			width: "100%",
			height: "300px",
			objectFit: "cover",
		},
	},
	testimonialContent: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		alignItems: "flex-start",
		background: "#fff",
		gap: "12px",
		padding: "20px",
		"@media only screen and (max-width: 768px)": {
			padding: "16px",
		},
	},
	testimonialCompanyLogo: {
		width: "auto",
		height: "auto",
	},
	testimonialCardFooter: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		gap: "5px",
		marginTop: "15px",
	},
	imageContainer: {
		position: "relative",
		minWidth: "260px",
		"@media only screen and (max-width: 768px)": {
			minWidth: "100%",
		},
	},
	testimonialSlide: {
		backgroundColor: "#F1FFFE",
	},
	tag: {
		top: "10px",
		right: "10px",
		padding: "6px 12px",
		position: "absolute",
		background: "#fff",
		color: "#000",
		backdropFilter: "blur(3px)",
		borderRadius: "50px",
	},
	combineSection: {
		position: "relative",
	},
	trustedContainer: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "#fff",
		padding: "30px 60px",
		width: "80%",
		maxWidth: "900px",
		borderRadius: "20px",
		"@media only screen and (max-width: 1200px)": {
			padding: "20px",
			width: "90%",
		},
		"@media only screen and (max-width: 768px)": {
			padding: "20px",
			width: "90%",
			top: "55%",
		},
		"@media only screen and (max-width: 600px)": {
			padding: "20px",
			width: "90%",
			top: "42%",
		},
	},
	trustedContainerHeader: {
		"& h2": {
			textAlign: "center",
			position: "relative",
			marginTop: "0 !important",
			"& img": {
				position: "relative",
				top: "8px",
			},
		},
	},
	trustImageContainer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginTop: "24px",
		"& img": {
			maxWidth: "110px",
			height: "auto",
		},
	},
	trustSectionContainer: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50% , -50%)",

		"& .trustedContainer": {
			backgroundColor: "#fff !Important",
		},
	},
	adaptSlider: {
		"@media only screen and (max-width: 600px)": {
			padding: "15px 15px 40px",
		},
		"@media only screen and (min-width: 1400px)": {
			padding: "15px 8rem 60px",
		},
		"@media only screen and (min-width: 1900px)": {
			padding: "15px 23rem 60px",
		},
	},
	absoulteCard: {
		position: "absolute",
		margin: "0 auto",
		width: "100%",
		top: "32%",
		"@media only screen and (max-width: 600px)": {
			top: "32%",
		},
	},
}));

const IndustryListing = () => {
	const classes = useStyles();

	const swiperRef = useRef(null);

	useEffect(() => {
		// Select all cards that should have the effect
		const cardsToAnimate = [
			document.querySelector(`.${classes.statsContainer} .${classes.customerExperencesBox}:first-child`),
			document.querySelector(`.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard3`),
			document.querySelector(`.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard2`),
			document.querySelector(`.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard0`),
			document.querySelector(`.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard4`),
			document.querySelector(`.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard6`),
			document.querySelector(`.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard1`),
			document.querySelector(`.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard5`),
			document.querySelector(`.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard7`),
		];

		const setupCard = (card) => {
			if (!card) return;

			card.classList.add("glass-effect");

			const setInitialPosition = () => {
				const rect = card.getBoundingClientRect();
				const topRightX = rect.width - 150;
				const topRightY = 0;

				card.style.setProperty("--before-left", `${topRightX}px`);
				card.style.setProperty("--before-top", `${topRightY}px`);
				card.style.setProperty("--before-opacity", "0.8");
			};

			setInitialPosition();

			let lastX = null;
			let lastY = null;

			const handleMouseMove = (e) => {
				const rect = card.getBoundingClientRect();
				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;

				lastX = x;
				lastY = y;

				card.style.setProperty("--before-left", `${x - 75}px`);
				card.style.setProperty("--before-top", `${y - 75}px`);
			};

			const handleMouseEnter = () => {
				if (lastX !== null && lastY !== null) {
					card.style.setProperty("--before-left", `${lastX - 75}px`);
					card.style.setProperty("--before-top", `${lastY - 75}px`);
				}
				card.style.setProperty("--before-opacity", "0.8");
			};

			const handleMouseLeave = () => {
				card.style.setProperty("--before-opacity", "0.8");
			};

			const handlers = {
				mousemove: handleMouseMove,
				mouseenter: handleMouseEnter,
				mouseleave: handleMouseLeave,
				resize: setInitialPosition,
			};

			card.handlers = handlers;

			card.addEventListener("mousemove", handlers.mousemove);
			card.addEventListener("mouseenter", handlers.mouseenter);
			card.addEventListener("mouseleave", handlers.mouseleave);
			window.addEventListener("resize", handlers.resize);
		};

		cardsToAnimate.forEach(setupCard);

		return () => {
			cardsToAnimate.forEach((card) => {
				if (!card?.handlers) return;

				const { handlers } = card;
				card.removeEventListener("mousemove", handlers.mousemove);
				card.removeEventListener("mouseenter", handlers.mouseenter);
				card.removeEventListener("mouseleave", handlers.mouseleave);
				window.removeEventListener("resize", handlers.resize);
			});
		};
	}, [classes]);

	const allIcons = [
		{
			img: leadCaptureIcon,
			title: "Auto lead capture",
		},
		{
			img: contactManagemntIcon,
			title: "Contact management",
		},
		{
			img: pipelineIcon,
			title: "Pipeline management",
		},
		{
			img: omniChannelIcon,
			title: "Omnichannel CRM",
		},
		{
			img: emailMarketingIcon,
			title: "Email marketing",
		},
		{
			img: quatationIcon,
			title: "Quotation generation",
		},
		{
			img: salesForecastIcon,
			title: "Sales forecasting",
		},
		{
			img: opportunityMangeIcon,
			title: "Opportunity management",
		},
		{
			img: aiChatbotIcon,
			title: "AI chatbot",
		},
		{
			img: whatsappCrmIcon,
			title: "WhatsApp CRM",
		},
		{
			img: mobileCrmIcon,
			title: "Mobile CRM",
		},
		{
			img: utmTrackingIcon,
			title: "UTM tracking",
		},
		{
			img: realTimeDashboardIcon,
			title: "Real-time dashboard",
		},
		{
			img: voipToolIcon,
			title: "VOIP tool integration",
		},
		{
			img: videoConferencingIcon,
			title: "Video conferencing",
		},
	];

	// Function to distribute icons across three tracks
	function distributeIcons(icons) {
		// Sort icons alphabetically to ensure consistent distribution
		const sortedIcons = [...icons].sort((a, b) => a.title.localeCompare(b.title));

		const logotrack1 = [];
		const logotrack2 = [];
		const logotrack3 = [];

		sortedIcons.forEach((icon, index) => {
			// Distribute icons based on their index
			switch (index % 3) {
				case 0:
					logotrack1.push(icon);
					break;
				case 1:
					logotrack2.push(icon);
					break;
				case 2:
					logotrack3.push(icon);
					break;
			}
		});

		return {
			logotrack1,
			logotrack2,
			logotrack3,
		};
	}

	// Get the distributed icons
	const { logotrack1, logotrack2, logotrack3 } = distributeIcons(allIcons);

	useEffect(() => {
		// Infinite scroll functionality

		class InfiniteScroll {
			constructor(row, speed) {
				this.row = row;
				this.track = row.querySelector(".logos-track");
				this.speed = speed;
				this.position = 0;
				this.direction = row.dataset.direction || "left";
				this.init();
			}

			init() {
				// Clone the track content
				const content = this.track.innerHTML;
				this.track.innerHTML = content + content + content;

				// Calculate total width
				const logos = this.track.querySelectorAll(".logo");
				let totalWidth = 0;
				logos.forEach((logo) => {
					totalWidth +=
						logo.offsetWidth +
						parseInt(getComputedStyle(logo).marginLeft) +
						parseInt(getComputedStyle(logo).marginRight);
				});

				// Set row height
				this.row.style.height = logos[0].offsetHeight + 20 + "px";

				// Set initial position for right-to-left movement
				if (this.direction === "left") {
					this.position = 0;
				} else {
					this.position = -this.track.offsetWidth / 3;
				}

				// Start animation
				this.animate();
			}

			animate() {
				const animate = () => {
					// Update position based on direction
					if (this.direction === "left") {
						this.position -= this.speed;
						// Reset position when one-third of content has scrolled
						const oneThirdWidth = -this.track.offsetWidth / 3;
						if (this.position <= oneThirdWidth) {
							this.position = 0;
						}
					} else {
						this.position += this.speed;
						// Reset position when one-third of content has scrolled
						if (this.position >= 0) {
							this.position = -this.track.offsetWidth / 3;
						}
					}

					this.track.style.transform = `translateX(${this.position}px)`;
					requestAnimationFrame(animate);
				};

				requestAnimationFrame(animate);
			}
		}

		// Initialize all rows with different speeds and directions
		document.querySelectorAll(".logos-row").forEach((row) => {
			const speed = parseFloat(row.dataset.speed) || 1;
			new InfiniteScroll(row, speed);
		});
	}, []);

	const benifitList = [
		{
			tag: "Integration",
			img: industryIntegration,
			title: "Seamless integrations to power every team",
			desc: "Pepper Cloud integrates with tools like WhatsApp, Google, and Slack—helping teams automate tasks, streamline communication, and enhance productivity without disrupting their existing workflows or preferred platforms.",
		},
	];

	const customerExperencesBoxContent = [
		{
			icon: contentIcon1,
			link: "/teams/best-crm-for-sales-reps/",
			heading: "Sales representatives",
			data: "Close deals faster with smart pipelines, automate follow-ups, and drive conversions and increase sales productivity.",
		},
		{
			icon: contentIcon2,
			link: "/teams/crm-for-sales-managers",
			heading: "Sales managers",
			data: "Forecast sales, keep track of your team’s performance with real-time dashboards, and train your team with actionable insights.",
		},
		{
			icon: contentIcon3,
			link: "/teams/crm-for-sales-development-reps",
			heading: "SDRs",
			data: "Prospect smarter, engage faster, and consistently convert leads into qualified meetings with best CRM for SDRs.",
		},
		{
			icon: contentIcon8,
			link: "/teams/crm-for-marketing-team/",
			heading: "Marketing teams",
			data: "Run high-performing campaigns with automation, audience segmentation, and omnichannel engagement tools tailored for modern marketers.",
		},
		{
			icon: contentIcon5,
			link: "/teams/crm-for-it",
			heading: "IT and tech teams",
			data: "Unify communication, manage integrations, and monitor service pipelines with a secure CRM built for tech operations.",
		},

		{
			icon: contentIcon6,
			link: "/teams/crm-for-business-owners",
			heading: "Business executive & owners",
			data: "Gain strategic oversight with executive dashboards, reporting tools, and custom insights to scale operations and monitor performance.",
		},
		{
			icon: contentIcon7,
			link: "/teams/crm-for-customer-support-teams",
			heading: "Customer support",
			data: "Deliver consistent support with shared inboxes, ticket tracking, and context-rich messaging across WhatsApp, chat, and email.",
		},

		{
			icon: contentIcon4,
			link: "/teams/crm-for-hr",
			heading: "HR and recruitment",
			data: "Streamline hiring workflows, automate interview scheduling, and track candidate journeys—all from one intelligent CRM dashboard.",
		},
	];

	const partners = [
		{ icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
		{ icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
		{ icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
		{ icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
		{
			icon: partnerIcon6,
			alt: "mustard seed systems corporation - Pepper Cloud Customer",
		},
		{
			icon: partnerIcon7,
			alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
		},
		{ icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
		{ icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
		{ icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
		{ icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
		{ icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
		{
			icon: partnerIcon6,
			alt: "mustard seed systems corporation - Pepper Cloud Customer",
		},
		{
			icon: partnerIcon7,
			alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
		},
		{ icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
	];

	const faqs = [
		{
			question: "How does team-specific CRM benefit my organisation?",
			answer: (
				<>
					It allows every department to work with tailored workflows, enhancing focus, accountability, and performance
					across your business.
				</>
			),
		},
		{
			question: "Is Pepper Cloud CRM suitable for sales teams?",
			answer: (
				<>
					Yes, it offers deal tracking, pipeline automation, and lead-nurturing tools specifically built for sales
					performance.
				</>
			),
		},
		{
			question: "Can marketing teams run campaigns through the CRM?",
			answer: (
				<>
					Absolutely. You can launch WhatsApp and email campaigns, track responses, and optimise performance using
					detailed insights.
				</>
			),
		},
		{
			question: "What CRM features support customer service teams?",
			answer: (
				<>
					Shared inboxes, ticket management, and full customer context help teams resolve queries faster and more
					effectively.
				</>
			),
		},
		{
			question: "Does Pepper Cloud work for HR and recruitment?",
			answer: (
				<>
					Yes, HR teams can manage candidate pipelines, automate scheduling, and streamline onboarding through custom
					workflows.
				</>
			),
		},
		{
			question: "How does Pepper Cloud CRM support IT teams?",
			answer: (
				<>
					It centralises communication, automates task flows, and integrates easily with APIs and dev tools for seamless
					ops.
				</>
			),
		},
		{
			question: "Can multiple teams collaborate on one CRM?",
			answer: (
				<>
					Yes. With role-based access and shared dashboards, different departments can work together while maintaining
					data visibility.
				</>
			),
		},
		{
			question: "Is onboarding included for all team setups?",
			answer: (
				<>
					Every plan includes training, support, and onboarding to ensure each team gets the most out of the platform.
				</>
			),
		},
		{
			question: "Can we integrate third-party tools that our teams use?",
			answer: (
				<>
					Definitely. Pepper Cloud connects with Google Workspace, Slack, Meta, and many other tools your teams already
					use.
				</>
			),
		},
		{
			question: "Is the CRM scalable for growing teams?",
			answer: (
				<>
					It grows with your business, adapting to team structures, increasing workloads, and expanding operations
					smoothly.
				</>
			),
		},
	];

	const adaptList = [
		{
			pointer: "All-in-one CRM",
			desc: "Manage leads, conversations, deals, and automation in one unified platform.",
			img: adaptImg1,
			alt: "Create whatsapp broadcast list",
		},
		{
			pointer: "Smart workflows",
			desc: "Automate repetitive tasks and follow-ups with intelligent, adaptable workflows.",
			img: adaptImg2,
			alt: "Create whatsapp broadcast message​",
		},
		{
			pointer: "Custom pipelines",
			desc: "Tailor your pipeline stages to match how your team sells.",
			img: adaptImg3,
			alt: "Create whatsapp broadcast message​",
		},
		{
			pointer: "Lead capture",
			desc: "Instantly collect leads via WhatsApp, Facebook, and web forms.",
			img: adaptImg4,
			alt: "CRM for Whatsapp broadcast",
		},
		{
			pointer: "Omnichannel inbox",
			desc: "Talk to customers via email, WhatsApp, and web chat easily.",
			img: adaptImg5,
			alt: "CRM for Whatsapp broadcast",
		},
	];

	return (
		<main>
			<SEO
				description={
					" Discover how Pepper Cloud CRM adapts to any industry and business size with AI, automation, and omnichannel tools to boost sales, save time, and grow faster."
				}
				jsonLd={[
					{
						"@context": "https://schema.org",
						"@type": "Organization",
						name: "Pepper Cloud",
						legalName: "Pepper Cloud PTE LTD",
						url: "https://peppercloud.com/",
						logo: "https://peppercloud.com/icons/logo.png",
						foundingDate: "2017",
						address: [
							{
								"@type": "PostalAddress",
								streetAddress: "#04-01/02",
								addressLocality: "Blk 79 Ayer Rajah Crescent",
								addressRegion: "SG",
								postalCode: "139955",
								addressCountry: "Singapore",
							},
							{
								"@type": "PostalAddress",
								streetAddress: "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
								addressLocality: "Bengaluru",
								addressRegion: "KA",
								postalCode: "560095",
								addressCountry: "India",
							},
						],
						contactPoint: {
							"@type": "ContactPoint",
							contactType: "customer support",
							telephone: "+6566562616",
							email: ["sales@peppercloud.com", "support@peppercloud.com"],
						},
						sameAs: [
							"https://twitter.com/peppercloudpte",
							"https://www.linkedin.com/company/peppercloud/",
							"https://www.facebook.com/PepperCloudPteLtd",
							"https://www.instagram.com/pepper.cloud/",
						],
					},
					{
						"@context": "https://schema.org/",
						"@type": "FAQPage",
						mainEntity: [
							{
								"@type": "Question",
								name: "What is the role of CRM in retail?",
								acceptedAnswer: {
									"@type": "Answer",
									text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
								},
							},
							{
								"@type": "Question",
								name: "Why is a specialized CRM necessary for e-commerce?",
								acceptedAnswer: {
									"@type": "Answer",
									text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
								},
							},
							{
								"@type": "Question",
								name: "Is investing in a CRM worthwhile for small businesses?",
								acceptedAnswer: {
									"@type": "Answer",
									text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
								},
							},
							{
								"@type": "Question",
								name: "Can Pepper Cloud assist with cart abandonment?",
								acceptedAnswer: {
									"@type": "Answer",
									text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
								},
							},
							{
								"@type": "Question",
								name: "How does Pepper Cloud facilitate multichannel sales?",
								acceptedAnswer: {
									"@type": "Answer",
									text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
								},
							},
						],
					},
				]}
				keywords="crm with whatsapp integration, crm whatsapp integration, whatsapp integration, WhatsApp-enabled CRM"
				ogData={{
					"og:image": ["/meta/og/1X1/home.png", "/meta/og/1024X512/home.png", "/meta/og/1200X630/home.png"],
				}}
				pathname={"https://peppercloud.com/whatsapp-crm/"}
				title={"CRM Solutions by Industry | Pepper Cloud - All-in-One CRM for Your Business"}
			/>

			<section className={classes.IndustrySection}>
				<div className="container">
					<div className={classes.aiSectionContainer}>
						<div className={classes.aiSectionLeft}>
							<motion.h1
								className="font-wix-semibold font-64  "
								initial={{ opacity: 1, y: 20 }}
								transition={{ duration: 0.3 }}
								whileInView={{ opacity: 1, y: 0 }}
							>
								AI-powered CRM built for every team
							</motion.h1>
							<motion.p
								className="font-wix-regular font-18  "
								initial={{ opacity: 1, y: 20 }}
								transition={{ duration: 0.3 }}
								whileInView={{ opacity: 1, y: 0 }}
							>
								Pepper Cloud AI-powered CRM empowers teams across sales, marketing, customer support, HR, IT, and
								leadership. With AI-driven automation, omnichannel communication, and team-specific workflows, it helps
								you streamline operations, boost productivity, and scale efficiently. Whether you're closing deals or
								hiring talent, our CRM aligns with your business goals and team dynamics seamlessly.
							</motion.p>
							<div className="buttonContaienr">
								{/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
								<Link
									className=" primaryButton font-inter-medium font-16 font-white"
									initial={{ opacity: 1, y: 20 }}
									to={"/contact/"}
									transition={{ duration: 0.3 }}
									whileInView={{ opacity: 1, y: 0 }}
								>
									Book a free demo
								</Link>
							</div>
						</div>
						<motion.div
							className={classes.aiSectionRight}
							initial={{ opacity: 1, y: 20 }}
							transition={{ duration: 0.3 }}
							whileInView={{ opacity: 1, y: 0 }}
						>
							<LazyImage alt={"WhatsApp CRM"} source={teamsPageHeroImg} width={"100%"} />
						</motion.div>
					</div>
				</div>
			</section>
			<section className={classes.performanceSection}>
				<div className="container">
					<div className={classes.integrationindustryHeader}>
						<div className={classes.integrationContent}>
							<motion.h2
								className="font-wix-semibold font-56 color-black7"
								initial={{ opacity: 1, y: 20 }}
								transition={{ duration: 0.3 }}
								whileInView={{ opacity: 1, y: 0 }}
							>
								Drive team performance across departments
							</motion.h2>
							<motion.p
								className="font-wix-regular font-18 colorWhite"
								initial={{ opacity: 1, y: 20 }}
								transition={{ duration: 0.3 }}
								whileInView={{ opacity: 1, y: 0 }}
							>
								Pepper Cloud AI-powered CRM empowers every department with tools designed for their goals. From closing
								sales and running campaigns to managing support, tech, or talent, our CRM adapts to each team’s workflow
								to accelerate business growth.
							</motion.p>
						</div>
					</div>
					<div className={classes.statsContainer}>
						{customerExperencesBoxContent.map((stat, index) => (
							<motion.div
								className={clsx(classes.customerExperencesBox)}
								key={index}
								transition={{ duration: 1, delay: index * 0.1 }}
								whileInView={{ opacity: [0, 1], y: [50, 0] }}
							>
								{/* <div className={classes.statsBoxHeader}>
                  <p className="font-18 color-purple3 font-wix-regular">
                    {stat.heading}
                  </p>
                </div> */}
								<div className={classes.customerExperencesBoxBody}>
									<div className={classes.statsFontImg}>
										<img alt={stat.alt} src={stat.icon} />
									</div>

									<p className="font-24 font-wix-semibold heading">{stat.heading}</p>
									<p className="font-16 font-wix-regular font-white description">{stat.data}</p>
									<Link className={classes.learnMorelink} to={stat.link}>
										<span className="font-18 font-white font-wix-medium">Learn more</span>{" "}
										<span className={classes.moreSideButton}>
											<img alt="Learn more" src={moreSideRightButton} />
										</span>
									</Link>
								</div>
							</motion.div>
						))}
					</div>
				</div>
			</section>

			<section className={classes.adaptFeatures}>
				<div className="container">
					<div className="header">
						<motion.h2
							className="font-wix-semibold font-56 color-black1"
							initial={{ opacity: 1, y: 20 }}
							transition={{ duration: 0.3 }}
							whileInView={{ opacity: 1, y: 0 }}
						>
							How Pepper Cloud adapts to your team
						</motion.h2>
						<motion.p
							className="font-wix-regular font-18 color-black1"
							initial={{ opacity: 1, y: 20 }}
							transition={{ duration: 0.3 }}
							whileInView={{ opacity: 1, y: 0 }}
						>
							Every team works differently, and Pepper Cloud CRM makes it easy to adapt. From sales pipelines and hiring
							stages to support workflows, we customise features, automations, and communication tools that align with
							your department’s goals.
						</motion.p>
					</div>
				</div>
				<Swiper
					autoplay={{
						delay: 0,
						disableOnInteraction: false,
					}}
					breakpoints={{
						// For smaller screens (mobile)
						0: {
							slidesPerView: "auto",
							freeMode: true,
							// grabCursor: false,
							spaceBetween: 15,
							// autoplay: false,
							// modules: [],
						},
						// For larger screens (desktop)
						// 768: {
						//   slidesPerView: "auto",
						//   slidesPerGroup: 3,
						//   spaceBetween: 30,
						//   grabCursor: true,
						// },
					}}
					className={classes.adaptSlider}
					grabCursor={true}
					loop={true}
					modules={[Autoplay]}
					speed={5000}
					slidesPerView={"auto"}
					// centeredSlides={true}
					spaceBetween={30}
				>
					{adaptList.map((point, index) => (
						<SwiperSlide className={classes.adaptsBox}>
							<div className={classes.adaptBoxHeader}>
								<img
									// alt={point.card.alt}
									className={classes.adaptBoxImg}
									src={point.img}
								/>
								<p className="font-24 font-wix-semibold ">{point.pointer}</p>
							</div>
							<div className={classes.adaptDescription}>
								<p className="font-wix-regular font-18  ">{point.desc}</p>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
			</section>
			<section className={classes.combineSection}>
				<section className={classes.bussinessSuccesSection}>
					<div className={classes.integrationHeaderItem}>
						<div className={classes.integrationContent}>
							<motion.h2
								className="font-wix-semibold font-56 color-black7"
								initial={{ opacity: 1, y: 20 }}
								transition={{ duration: 0.3 }}
								whileInView={{ opacity: 1, y: 0 }}
							>
								Trusted by Growing Businesses Across Sectors
							</motion.h2>
						</div>
					</div>

					<section>
						<div className="logos-container">
							<div className="scroll-container">
								<div className="logos-row" data-direction="left" data-speed="0.8">
									<div className="logos-track">
										{logotrack1.map((logo) => (
											<div className="logo font-18 font-wix-medium">
												<img alt={`${logo.title} integration`} src={logo.img} />
												<p>{logo.title}</p>
											</div>
										))}
									</div>
								</div>

								<div className="logos-row" data-direction="right" data-speed="0.4">
									<div className="logos-track">
										{logotrack2.map((logo) => (
											<div className="logo font-18 font-wix-medium">
												<img alt={`${logo.title} integration`} src={logo.img} />
												<p>{logo.title}</p>
											</div>
										))}
									</div>
								</div>

								<div className="logos-row" data-direction="left" data-speed="0.8">
									<div className="logos-track">
										{logotrack3.map((logo) => (
											<div className="logo font-18 font-wix-medium">
												<img alt={`${logo.title} integration`} src={logo.img} />
												<p>{logo.title}</p>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</section>
				</section>
				<div className={classes.absoulteCard}>
					<TruestedSection background={true} />
				</div>

				{benifitList.map((benifit, index) => (
					<section className={classes.integrationSection}>
						<div className="container">
							<div className={classes.integrationHeader}>
								<div className={classes.integrationLeft}>
									<motion.div
										className="sectionTag"
										initial={{ opacity: 1, y: 20 }}
										transition={{ duration: 0.3 }}
										whileInView={{ opacity: 1, y: 0 }}
									>
										<p className="font-18  font-wix-semibold color-blue1">{benifit.tag}</p>
									</motion.div>
									<motion.h2
										className="font-wix-semibold font-56 color-black1"
										initial={{ opacity: 1, y: 20 }}
										transition={{ duration: 0.3 }}
										whileInView={{ opacity: 1, y: 0 }}
									>
										{benifit.title}
									</motion.h2>
									<motion.p
										className="font-wix-regular font-18 color-black2 mt20"
										initial={{ opacity: 1, y: 20 }}
										transition={{ duration: 0.3 }}
										whileInView={{ opacity: 1, y: 0 }}
									>
										{benifit.desc}
									</motion.p>
									<div className="buttonContaienr">
										<Link className=" primaryButtonOutline font-wix-medium font-18  " to={"/crm-integrations"}>
											Explore CRM integrations
										</Link>
									</div>
								</div>
								<div className={classes.integrationRight}>
									<img alt={benifit.title} className={classes.integrationRightImage} src={benifit.img} />
								</div>
							</div>
						</div>
					</section>
				))}
			</section>
			<section className={classes.aiPoweredContainer}>
				<div className="container">
					<div className={classes.aiPoweredClientContainer}>
						<motion.h2
							className="font-wix-medium font-24 color-black1"
							initial={{ opacity: 1, y: 20 }}
							transition={{ duration: 0.3 }}
							whileInView={{ opacity: 1, y: 0 }}
						>
							Best AI-powered WhatsApp sales CRM tool - built for growing businesses
						</motion.h2>
					</div>
				</div>
				<Swiper
					allowTouchMove={false}
					autoplay={{
						delay: 100,
						disableOnInteraction: false,
						pauseOnMouseEnter: false,
					}}
					className={classes.partnerSlider}
					loop={true}
					modules={[Autoplay]}
					slidesPerView="auto"
					spaceBetween={60}
					speed={2000}
				>
					{partners.map((partner) => (
						<SwiperSlide className={classes.partnerSlide}>
							<img alt={partner.alt} src={partner.icon} />
						</SwiperSlide>
					))}
				</Swiper>
			</section>
			<section className={classes.testimonialSlide}>
				<TestimonialSlider
					desc={"Discover how businesses are transforming customer engagement with Pepper Cloud."}
					heading={"Trusted by businesses worldwide"}
					noButton={true}
				/>
			</section>

			<div className={classes.wpFaq}>
				<FaqSection backgroundColor={"#FFFFFF"} faqs={faqs} heading={"Frequently asked questions"} />
			</div>
			<section className={classes.commonPageFooterSection}>
				<div className="container">
					<div className="centerContainer">
						<motion.h2
							className="font-wix-medium font-56 font-white"
							initial={{ opacity: 1, y: 30 }}
							transition={{ duration: 0.5 }}
							whileInView={{ opacity: 1, y: 0 }}
						>
							Powering productivity across teams and workflows
						</motion.h2>
						<Link
							className="primaryButton font-20 font-wix-medium font-white"
							to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
						>
							Get started
						</Link>
					</div>
				</div>
			</section>
		</main>
	);
};

export default IndustryListing;
